import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
  BoxTitle,
  BoxContainer,
  BoxHead,
  Underline,
} from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import NotFoundModel from "../../Components/NotFoundModel";
import MaintenanceTable from "../../Components/Assets/MaintenanceTable";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import EditMaintenanceDetail from "../../Components/Assets/EditMaintenanceDetail";
import { toast } from "react-toastify";
import MaintenanceDetail from "../../Components/Assets/MaintenanceDetail";
import { IoChevronBackOutline } from "react-icons/io5";
import SideModal from "../../Components/SideModal";

const AssetMaintenance = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const navigate = useNavigate();
  const { assetId, propId } = useParams();
  const [selectedData, setSelectedData] = useState("");
  const [apiData, setApiData] = useState();
  const [isShowEditMaintenance, setIsShowEditMaintenance] = useState(false);
  const [vendorName, setVendorName] = useState("");
  const [vendorMobile, setVendorMobile] = useState("");
  const [isMaintenanceDetails, setIsMaintenanceDetails] = useState(false);
  const [selectedPropertyAssets, setSelectedPropertyAssets] = useState([]);
  const [showAddVendorForm, setShowAddVendorForm] = useState(false);
  const [expenseData, setExpenseData] = useState([]);

  const fetchInitData = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/expense/initial-values`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    setExpenseData(response.data.data);
  };

  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/asset/list/maintenance/${assetId}/${propId}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.data === false) error = true;
    else {
      setApiData(res?.data);
      fetchInitData();
    }
  };

  const getError = (res) => {};

  const {
    isLoading: isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
    }, 100);

    return () => {
      clearTimeout(handler);
    };
  }, [assetId, propId]);

  //------- Add vendor -------
  const addVendorFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/vendor/add`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onAddVendorSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setShowAddVendorForm(false);
      setVendorMobile("");
      setVendorName("");
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onAddVendorError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading: addVendorLoading,
    mutate: addVendorMutate,
    data: vendorList,
  } = useMutation(addVendorFunction, {
    onSuccess: onAddVendorSuccess,
    onError: onAddVendorError,
  });
  const handleMaintenanceEditClose = () => {
    setIsShowEditMaintenance(false);
    setShowAddVendorForm(false);
    setVendorMobile("");
    setVendorName("");
    // setIsAddAssetModal(true);
  };
  const handleVendorFormClose = () => {
    setShowAddVendorForm(false);
    setVendorMobile("");
    setVendorName("");
  };
  //-------Edit MaintenanceDetail -------
  const editMaintenanceDetailFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/asset/maintenance/edit`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const editMaintenanceDetailSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsShowEditMaintenance(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const editMaintenanceDetailError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading: editMaintenanceDetailLoading,
    mutate: editMaintenanceDetailMutate,
  } = useMutation(editMaintenanceDetailFunction, {
    onSuccess: editMaintenanceDetailSuccess,
    onError: editMaintenanceDetailError,
  });
  const assetName = data?.assetName;
  const PropName = data?.propName;

  //------- MaintenanceDetail -------
  const maintenanceDetailFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/asset/maintenance/add`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const maintenanceDetailSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsMaintenanceDetails(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const maintenanceDetailError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading: maintenanceDetailLoading,
    mutate: maintenanceDetailMutate,
  } = useMutation(maintenanceDetailFunction, {
    onSuccess: maintenanceDetailSuccess,
    onError: maintenanceDetailError,
  });
  const handleMaintenanceClose = () => {
    setIsMaintenanceDetails(false);
    setShowAddVendorForm(false);
    setVendorMobile("");
    setVendorName("");
    // setIsAddAssetModal(true);
  };

  return (
    <>
      <BoxContainer>
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            <BackWrapper>
              <BackButton onClick={() => navigate(-1)}>
                <IoChevronBackOutline size={20} />
              </BackButton>
              <div>
                <span className="flex items-center">Maintenance Detail</span>
                {/* <Underline /> */}
              </div>
            </BackWrapper>

            <div className="flex gap-4 items-center mt-2 sm:flex-row flex-col">
              <AssetNameCard>{assetName}</AssetNameCard>
              <PropNameCard>{PropName}</PropNameCard>
            </div>
          </BoxTitle>
          <UploadWrapper>
            <Button type="button" onClick={() => setIsMaintenanceDetails(true)}>
              <p className="text-sm">{"Add Maintenance"}</p>
            </Button>
          </UploadWrapper>
        </BoxHead>

        <SideModal
          isOpen={isShowEditMaintenance}
          onClose={() => setIsShowEditMaintenance(false)}
        >
          <EditMaintenanceDetail
            setIsShowEditMaintenance={setIsShowEditMaintenance}
            selectedData={selectedData}
            editMaintenanceDetailMutate={editMaintenanceDetailMutate}
            editMaintenanceDetailLoading={editMaintenanceDetailLoading}
            vendorList={vendorList?.data?.vendors}
            showAddVendorForm={showAddVendorForm}
            setShowAddVendorForm={setShowAddVendorForm}
            expenseData={expenseData}
            addVendorMutate={addVendorMutate}
            addVendorLoading={addVendorLoading}
            vendorName={vendorName}
            setVendorName={setVendorName}
            vendorMobile={vendorMobile}
            setVendorMobile={setVendorMobile}
            handleMaintenanceEditClose={handleMaintenanceEditClose}
            handleVendorFormClose={handleVendorFormClose}
          />
        </SideModal>

        <SideModal
          isOpen={isMaintenanceDetails}
          onClose={() => setIsMaintenanceDetails(false)}
        >
          <MaintenanceDetail
            setIsMaintenanceDetails={setIsMaintenanceDetails}
            maintenanceDetailMutate={maintenanceDetailMutate}
            maintenanceDetailLoading={maintenanceDetailLoading}
            selectedData={selectedData}
            vendorList={vendorList?.data?.vendors}
            showAddVendorForm={showAddVendorForm}
            setShowAddVendorForm={setShowAddVendorForm}
            expenseData={expenseData}
            addVendorMutate={addVendorMutate}
            addVendorLoading={addVendorLoading}
            vendorName={vendorName}
            setVendorName={setVendorName}
            vendorMobile={vendorMobile}
            setVendorMobile={setVendorMobile}
            handleMaintenanceClose={handleMaintenanceClose}
            handleVendorFormClose={handleVendorFormClose}
            assetId={assetId}
            propId={propId}
          />
        </SideModal>

        {!error && !isLoading && apiData && (
          <TableWrapper>
            <MaintenanceTable
              apiData={error ? [] : apiData?.length > 0 ? apiData : []}
              setSelectedData={setSelectedData}
              selectedData={selectedData}
              setIsShowEditMaintenance={setIsShowEditMaintenance}
            />
            {apiData?.length == 0 && !isLoading && <NotFoundModel />}
          </TableWrapper>
        )}
        {error && !isLoading && <NotFoundModel />}
        {(isLoading || isRefetching) && <Loading />}
      </BoxContainer>
    </>
  );
};

const TableWrapper = tw.h1`my-8 border  bg-white rounded-md `;
const AssetNameCard = tw.div`bg-black text-white text-base text-center px-4 py-2 rounded-lg`;
const PropNameCard = tw.div`bg-gray-200 text-gray-700 text-base text-center px-4 py-2 rounded-lg`;
const UploadWrapper = tw.div`flex items-center gap-3 `;
const Button = tw.button`
 text-white bg-primary-color transition hover:bg-hover-color  flex items-center !ml-auto space-x-1 justify-center w-40   h-10 text-xs  whitespace-nowrap rounded px-6
`;
const BackWrapper = tw.div`flex items-center`;
const BackButton = tw.button`hover:bg-gray-200 items-center p-1 rounded-full transition-colors`;
export default AssetMaintenance;
